import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import ProctorApproval from '../Approvals/ProctorApproval';

const ApproveProctor = observer(class ApproveProctor extends React.Component {
  constructor() {
    super();
    this.nextCard = this.nextCard.bind(this);
    this.prevCard = this.prevCard.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      card: 1
    }

    this.getPendingApprovals();

    SessionStore.getCurrentTime();
  }

  getPendingApprovals() {
    let query = `?examSid=${this.props.examSid}&status=requested`;

    if(typeof this.props.examSid === 'undefined') {
      const segment2 = getURLSegment(this, 2);

      if(typeof segment2 !== 'undefined') {
        query = `?examSid=${getURLSegment(this, 2)}&status=requested`
      } else {
        query = `?status=requested`
      }
    }

    this.props.store.ProctorStore.getPendingApprovals(query);
  }

  isActive(card) {
    if(this.state.card === card) {
      return 'slide-active';
    } else if(this.state.card > card) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  nextCard() {
    this.setState({
      card: this.state.card + 1
    });
  }

  prevCard() {
    this.setState({
      card: this.state.card - 1
    });
  }

  renderResults() {
    const { store, translation } = this.props;
    const { ProctorStore, SessionStore } = store;
    const { pendingApprovals } = ProctorStore;

    if(pendingApprovals.length > 0) {
      return (
        <div className="approval-wrap">
          <ul className="approvals slide-wrap">
            {pendingApprovals.map(
              (key, i) =>
                <li key={i} className={this.isActive(i + 1)}>
                  <ProctorApproval
                    approval={key}
                    proctor={key.proctorAccount}
                    approvalCallback={this.nextCard}
                    {...this.props}
                  />
                </li>
            )}

            <li className={`panel panel--brief approval__done ${this.isActive(pendingApprovals.length + 1)}`}>
              {this.state.card > pendingApprovals.length &&
                <div>
                  <h2 className="panel__title">{translation.done_heading}</h2>
                  <span>{translation.done_body}</span>
                </div>
              }
            </li>
          </ul>

          {this.state.card !== 1 && this.state.card !== pendingApprovals.length + 1 &&
            <button
              className="approvals__nav approvals__prev"
              onClick={this.prevCard}
            >
              <icons.iconChevronLeft />
              <span className="meta">{translation.prev}</span>
            </button>
          }

          {this.state.card !== pendingApprovals.length && this.state.card !== pendingApprovals.length + 1 &&
            <button
              className="approvals__nav approvals__next"
              onClick={this.nextCard}
            >
              <icons.iconChevronRight />
              <span className="meta">{translation.next}</span>
            </button>
          }
        </div>
      )
    } else if(!SessionStore.loading && pendingApprovals.length === 0) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="wrap">
          <div className="panel__section">
            {this.renderResults()}
          </div>
        </div>
      </div>
    )
  }
})

export default translate('ApproveProctor')(ApproveProctor);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/ApproveProctor.js